import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const TextArea = ({
  name,
  placeholder,
  displayName,
  icon,
  value,
  error,
  touched,
  shrink,
  handleChange,
  classes,
  isHorizontal,
  horizontalLabelClass,
  disabled,
  isDisplayAbleOnly,
  rows,
  withoutNewline,
  maxLength,
  firstCharDirection,
}) => {
  const { t } = useTranslation();

  const handleTextChange = (name, value) => {
    let text = value;
    if (withoutNewline) text = text.replace(/\r?\n|\r/g, ''); // Remove newlines from pasted content
    handleChange(name, text);
  };

  const shrinkLabel = shrink ? ' shrink-label' : '';

  const getDirectionFromFirstChar = (text) => {
    const firstChar = text?.[0] || '';
    const isFirstCharRTL = firstChar ? !/^[a-zA-Z0-9]/.test(firstChar) : false;
    return isFirstCharRTL ? 'rtl' : 'ltr';
  };
  const direction = firstCharDirection ? getDirectionFromFirstChar(value) : undefined;

  return (
    <div
      className={`custom-input-box${classes ? ' ' + classes : ''} ${
        isHorizontal ? 'd-flex align-items-center w-100' : ''
      } ${isDisplayAbleOnly ? 'read-only' : ''}`}
    >
      {displayName && (
        <label
          htmlFor={name}
          className={`${!touched && error ? 'label-error' + shrinkLabel : shrinkLabel} ${
            isHorizontal ? horizontalLabelClass : ''
          }`}
        >
          {t(displayName)}
        </label>
      )}
      <div className='d-flex flex-column w-100'>
        <div className={`custom-input-field ${isHorizontal ? 'w-100' : ''}`}>
          <textarea
            disabled={disabled}
            rows={rows}
            maxLength={maxLength}
            type='text'
            style={{ resize: 'none', ...(direction ? { direction } : {}) }}
            id={name}
            name={name}
            className={`${!touched && error ? 'input-error' : ''}`}
            placeholder={t(placeholder)}
            value={value}
            autoComplete='off'
            onChange={(e) => {
              !isDisplayAbleOnly ? handleTextChange(e.target.name, e.target.value) : null;
            }}
          />
          {icon && <img src={icon} className='icon' />}
        </div>
        {!touched && error && <p className='form-field-error'>{t('error ' + error)}</p>}
      </div>
    </div>
  );
};

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  shrink: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  classes: PropTypes.string,
  disabled: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  horizontalLabelClass: PropTypes.string,
  isDisplayAbleOnly: PropTypes.bool,
  rows: PropTypes.number,
  withoutNewline: PropTypes.bool,
  maxLength: PropTypes.number,
  firstCharDirection: PropTypes.bool,
};

export default TextArea;
